import axios from 'axios';
import { BUSINESS_ADMIN_HOST } from 'api/constants';

const PRODUCTS_URL = `${BUSINESS_ADMIN_HOST}/v1/products`;
const HARDWARE_BASE_PRODUCTS_URL = `${BUSINESS_ADMIN_HOST}/v1/products/hardware-base-products`;

export function getHardwareProductsApi() {
  return axios.get(PRODUCTS_URL, {
    params: {
      type: 'HARDWARE',
    },
  });
}

export function getHardwareBaseProductsApi() {
  return axios.get(HARDWARE_BASE_PRODUCTS_URL);
}

export function createHardwareProductApi(productData) {
  return axios.post(PRODUCTS_URL, productData);
}

export function updateHardwareProductApi(productData) {
  return axios.put(`${PRODUCTS_URL}/${productData.id}`, productData);
}

export function deleteHardwareProductApi(productId) {
  return axios.delete(`${PRODUCTS_URL}/${productId}`);
}

export function getHardwareCatalogueLogs(page, size) {
  return axios.get(`${BUSINESS_ADMIN_HOST}/v1/logs?group=products_hardware`, {
    params: { page, size },
  });
}
